// extracted by mini-css-extract-plugin
module.exports = {"controller":"styles_controller__XDYV4","btn":"styles_btn__1PzH4"};